.error {
  margin-top: var(--space-3);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background-color: var(--color-danger-bg);
  color: var(--color-danger-fg);
  font-size: var(--font-size-sm);
}
